import React from 'react';
import { DatoCmsNavigationBar } from '../../../schema/datocms';
import { DatoCmsLink } from '../../../schema/datocms/blocks';
import { Themes } from '../../../schema/enum/themes';
import IconWithText from '../../icon/icon-with-text';
import Link from '../../link/link';
import { useThemeClassMap } from '../../theme/useThemeClassMap';

const NavigationBarComponent = ({ leftLink, rightLink, relatedPageLinks, currentPageSlug }: DatoCmsNavigationBar & { currentPageSlug?: string }): React.ReactElement => {
    const left: DatoCmsLink | undefined = leftLink && leftLink.length > 0 ? leftLink[0] : undefined;
    const right: DatoCmsLink | undefined = rightLink && rightLink.length > 0 ? rightLink[0] : undefined;

    const themeClass = useThemeClassMap(Themes.WHITE);

    const justificationClass: string = leftLink || rightLink ? 'justify-between' : 'justify-start lg:justify-between';

    return (
        <div className={`container mx-auto flex ${justificationClass} py-8 ${themeClass}`}>
            <div>
                { left && <Link className="lg:float-left btn link secondary"
                    internalPageReference={left.internalPageReference}
                    internalPageSectionId={left.internalSectionComponentId}
                    externalPageUrl={left.externalPageUrl}>
                    <IconWithText iconName="west" text={left.displayText || ''}></IconWithText>
                </Link>
                }
            </div>

            {
                relatedPageLinks && relatedPageLinks.length > 0 && <ul className="flex flex-col lg:flex-row lg:justify-center space-y-4 lg:space-y-0 lg:space-x-8">
                    {
                        relatedPageLinks.map((link, index) =>
                            <li key={index} className={`font-bold uppercase ${currentPageSlug === link.internalPageReference?.slug ? 'border-b-8 border-theme-secondary hover:border-theme-secondary-alt' : ''}`}>
                                <Link internalPageReference={link.internalPageReference} internalPageSectionId={link.internalSectionComponentId}
                                    externalPageUrl={link.externalPageUrl}
                                    title={link.descriptiveTitle}>
                                    {link.displayText}
                                </Link>
                            </li>)
                    }
                </ul>
            }


            <div>
                { right &&<Link className="lg:float-left btn link secondary"
                    internalPageReference={right.internalPageReference}
                    internalPageSectionId={right.internalSectionComponentId}
                    externalPageUrl={right.externalPageUrl}>
                    <IconWithText reverseIconWithText={true} iconName="east" text={right.displayText || ''}></IconWithText>
                </Link>
                }
            </div>
        </div>
    );
};

export default NavigationBarComponent;
